module.exports = __webpack_public_path__ + "img/beard-4.7fbab8a9.svg";